import React from "react";

/* Phase Rebrand — onebrain wordmark.
 *
 * The brand name reads "onebrain" with the letters "ai" highlighted in
 * brand-blue (#1E7BFF) — they spell "AI", which is the entire point of the
 * product. The remaining letters are dark charcoal (#2A2D34).
 *
 * Always render the wordmark via this component when it appears as TEXT
 * (header, footer, in-app brand mentions). Use the image lockup only on
 * the public landing page hero where the brain mark + tagline are together.
 *
 * sizes: 'sm' header/footer · 'md' default · 'lg' login hero · 'xl' landing
 */
const SIZE_CLASSES = {
  sm: "text-base",
  md: "text-xl",
  lg: "text-3xl sm:text-4xl",
  xl: "text-5xl sm:text-6xl lg:text-7xl",
};

export default function Wordmark({
  size = "md",
  className = "",
  inkClassName = "text-[#2A2D34]",
  testid = "wordmark",
}) {
  return (
    <span
      className={`font-serif tracking-tight select-none lowercase ${SIZE_CLASSES[size] || SIZE_CLASSES.md} ${inkClassName} ${className}`}
      data-testid={testid}
    >
      onebr<span className="text-[#1E7BFF]" data-testid={`${testid}-ai-accent`}>ai</span>n
    </span>
  );
}
